export { default } from './ImageTooltip';
